import Grid, {  GridProps } from '@material-ui/core/Grid'

const GridItem = ({ children, xs = 12, ...rest }: Omit<GridProps, 'container' | 'item'>) => {
  return (
    <Grid xs={xs} {...rest} item>
      {children}
    </Grid>
  )
}

export default GridItem

// xs, extra-small: 0
// sm, small:       480
// md, medium:      720
// lg, large:       960
// xl, extra-large: 1280
